import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

export const SimulatorStyles = styled.div`
  max-width: 53.25rem;
  .container {
    box-shadow: var(--theme-box-shadow);
    width: 100%;
    border-radius: var(--theme-border-radius);
    overflow: hidden;
    display: flex;
    flex-direction: row;
  }
  .form {
    width: 55%;
    padding: 1rem;
    background-color: #fff;
  }

  .loan-result {
    width: 45%;
  }
  .disclaimer {
    display: flex;
    width: 100%;
    justify-content: end;
  }

  ${CONFIG.media.mobileMd} {
    .container {
      flex-direction: column;
    }
    .form,
    .loan-result {
      width: 100%;
    }
  }
`
